__turbopack_context__.v({
  "delete": "SitLDW_delete",
  "icon": "SitLDW_icon",
  "iconCircle": "SitLDW_iconCircle",
});
